import { useQuery, useMutation, useQueryClient } from 'react-query';

import api from '../../utils/api';
import { FETCH_TAGS, CREATE_TAGS } from '../../constants/endpoints';
import { useVpSnackbar } from '../../vp-ui';

const fetchTags = () => api.get(FETCH_TAGS);
export const useFetchTags = () => useQuery([FETCH_TAGS], fetchTags);

const createTags = (payload) => api.post(CREATE_TAGS, payload);

export const useCreateTag = () => {
  const queryClient = useQueryClient();
  const { addSnackbarSuccess } = useVpSnackbar();

  return useMutation(createTags, {
    onSuccess: () => {
      queryClient.invalidateQueries(FETCH_TAGS);
      addSnackbarSuccess({ message: 'Successfully Created New Tag' });
    }
  });
};



// WEBPACK FOOTER //
// ./src/hooks/react-query/useTagData.js